<section class="mis_dropdown">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="dropfilter__flex">
                    <div class="drop__widthone">
                        <div class="dropsearch_flex">
                            <div class="dropwidth">
                                <select name="dropdown" class="mis_select" id="dropdown">
                                    <option value="1">All</option>
                                    <option value="2">State</option>
                                    <option value="3">City</option>
                                    <option value="4">Campus</option>
                                </select>
                            </div>
                            <div class="searchwidth">
                                <div class="input-group">
                                    <input type="text" class="form-control misinput_control" placeholder="Search">
                                    <div class="input-group-btn">
                                        <button class="btn drop_iconsearch" type="submit">
                                            <i class="fa fa-search" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drop__widthtwo">
                        <button class="dropdown-toggle month_dropshow" type="button" data-toggle="dropdown">
                            <img src="../../assets/image/filter.png" alt="filter" class="cctv_filter">
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right mis_select_show"
                            style="position: absolute;transform: translate3d(965px,45px,0px);top: 0px;left: 0px;will-change: transform;"
                            x-placement="bottom-end">
                            <li><a href="#" class="dropdown-item">HTML</a></li>
                            <li><a href="#" class="dropdown-item">CSS</a></li>
                            <li><a href="#" class="dropdown-item">JavaScript</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="search_mobshow">
                    <div>
                        <h6 class="mob_searchhd">Search by</h6>
                    </div>
                    <div class="searchitem_scroll">
                        <ul class="search_items">
                            <li><a href="#">Admission no </a></li>
                            <li><a href="#">School</a></li>
                            <li><a href="#">State</a></li>
                            <li><a href="#">Zone</a></li>
                            <li><a href="#">City</a></li>
                            <li><a href="#">Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section start -->
<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="state__sec">
                    <ul class="state__list" *ngFor="let data of dvr">
                        <li>
                            <div class="statelist__flex">
                                <div class="statetitle__flex">
                                    <div>
                                        <h5 class="state__name">{{data.buildingId}}</h5>
                                    </div>
                                    <div>
                                        <h6 class="state__dvr">ipAddres<span
                                                class="dvr__color">{{data.ipAddress}}</span>
                                        </h6>
                                    </div>
                                </div>

                                <div class="">
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <div class="card-head" id="headingOne">
                                                <div class="statelist__flexx collapsed" data-toggle="collapse"
                                                    data-target="#collapseOne" aria-expanded="false" 
                                                    aria-controls="collapseOne">
                                                    <div class="cctv__collapse">
                                                        <div class="dvr__border__right">
                                                            <h6 class="state__dvr">userName<span
                                                                    class="dvr__color"></span>{{data.userName}}</h6>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">password</h6>
                                                            <h5 class="cctv__number">{{data.password}}</h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">cctvCheckDate</h6>
                                                            <h5 class="cctv__number">{{data.cctvCheckDate}}</h5>
                                                        </div>
                                                        <div>
                                                            <h6 class="cctv__title">channelsNo</h6>
                                                            <h5 class="cctv__number">{{data.channelsNo}}</h5>
                                                        </div>
                                                        <div>
                                                            <a routerLink="/livecctv" h ref="#"><button type="button"
                                                                    class="cctv_livebtn">Live</button></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-expansion-panel-header>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="cctv_video_show">
                                                        <div class="video_width">
                                                            <button class="btn-1" (click)="openvideo()">
                                                                <figure class="mb-0">
                                                                    <img src="{{data.cctvFramS3Url}}"
                                                                         alt="cctvimg">
                                                                </figure>
                                                                <p class="cctv_camno">C : 1</p>
                                                            </button>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                        <div class="video_width">
                                                            <figure class="mb-0">
                                                                <img src="../../assets/image/cctvimg.png"
                                                                    class="cctvimg" alt="cctvimg">
                                                            </figure>
                                                            <p class="cctv_camno">C : 1</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>